export const enum BorderStyle {
  Dotted = 'dotted',
  Dashed = 'dashed',
  Solid = 'solid',
}

export type BorderStyleProps = {
  onChange: (value: BorderStyle) => void;
  value: BorderStyle;
};
